import {
  createBrowserRouter,
  createRoutesFromElements,
  Navigate,
  Outlet,
  Route,
  RouterProvider,
} from 'react-router-dom';

import Authenticated from '../components/Access/Authenticated';
import Unauthenticated from '../components/Access/Unauthenticated';
import AutoNavigator from '../components/AutoNavigator';
import { ClassContextProvider } from '../modules/class/Context';
import { CourseContextProvider } from '../modules/course/Context';
import CourseChannel from '../modules/course/CourseChannel';
import { PollContextProvider } from '../modules/poll/Context';
import AttendancePage from '../pages/attendance';
import AuthPage from '../pages/auth';
import HomePage from '../pages/home';
import NewPollPage from '../pages/new-poll';
import PollPage from '../pages/poll';
import TimerPage from '../pages/timer';
import RestrictedPage from '../pages/restricted';
import routes from './router';
import useAllRoutes from './vm';
import MetadataFetcher from '../components/MetadataFetcher';
import { PusherContextProvider } from '../pusher/PusherContext';
import UserChannel from '../modules/auth/UserChannel';

const AllRoutes = () => {
  useAllRoutes();

  const router = createBrowserRouter(
    createRoutesFromElements(
      <Route
        element={
          <AutoNavigator>
            <Outlet />
          </AutoNavigator>
        }
      >
        <Route
          element={
            <Unauthenticated>
              <Outlet />
            </Unauthenticated>
          }
        >
          <Route path={routes.auth.path} element={<AuthPage />} />
        </Route>
        <Route
          element={
            <Authenticated>
              <Outlet />
            </Authenticated>
          }
        >
          <Route
            element={
              <PusherContextProvider>
                <Outlet />
              </PusherContextProvider>
            }
          >
            <Route
              element={
                <MetadataFetcher>
                  <Outlet />
                </MetadataFetcher>
              }
            >
              <Route path={routes.home.path} element={<HomePage />} />
              <Route
                element={
                  <CourseContextProvider>
                    <Outlet />
                  </CourseContextProvider>
                }
              >
                <Route
                  element={
                    <CourseChannel>
                      <Outlet />
                    </CourseChannel>
                  }
                >
                  <Route
                    element={
                      <ClassContextProvider>
                        <Outlet />
                      </ClassContextProvider>
                    }
                  >
                    <Route
                      element={
                        <UserChannel>
                          <Outlet />
                        </UserChannel>
                      }
                    >
                      <Route path={routes.attendance.path} element={<AttendancePage />} />
                    </Route>
                    <Route
                      element={
                        <PollContextProvider>
                          <Outlet />
                        </PollContextProvider>
                      }
                    >
                      <Route path={routes.newPoll.path} element={<NewPollPage />} />
                      <Route path={routes.poll.path} element={<PollPage />} />
                    </Route>
                  </Route>
                </Route>
              </Route>
              <Route path={routes.timer.path} element={<TimerPage />} />
              <Route path={routes.restrictedPage.path} element={<RestrictedPage />} />
            </Route>
          </Route>
        </Route>
        <Route path="*" element={<Navigate to={routes.home.path} replace />} />
      </Route>
    )
  );

  return <RouterProvider router={router} />;
};

export default AllRoutes;
